module.exports = __webpack_public_path__ + "0af5d249/img/print-icon.d8dbbca5.svg";